module.exports = __webpack_public_path__ + "img/03.20215e2f.png";